import Vue from "vue";
import Router from "vue-router";
import Storage from "vue-web-storage";
import VueSessionStorage from "vue-sessionstorage";
import store from "@/vuex/store";
import {HTTP} from "@/http-common";
import {getJibuName} from "@/data/jibuMapping";

Vue.use(VueSessionStorage)
Vue.use(Storage)
// eslint-disable-next-line no-unused-vars
const session = Vue.prototype.$session;
/** 메인 페이지 */
const MainContainer = () => import('@/views/MainContainer.vue');
// const ErrorPage = () => import('@/views/error/ErrorGone410.vue');
const JoinPointContainer = () => import('@/views/join/JoinPointContainer.vue');
const JoinPointSocialContainer = () => import('@/views/join/JoinPointSocialContainer.vue');
const JoinSocialContainer = () => import('@/views/join/JoinSocialContainer.vue');
const KakaoErrorPage = () => import('@/views/error/KakaoErrorPage.vue');
// 추가 정보 페이지
// const MemberInfoNew = () => import('@/views/any/MemberInfoNew.vue');
// 첨부서류 페이지
// const MemberPaperAttachNew = () => import('@/views/any/MemberPaperAttachNew.vue');


Vue.use(Router)

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {   //본인인증
            path: '/',
            name: 'Main',
            meta: {order: 1},
            component: MainContainer,
            beforeEnter: async (to, from, next) => {
                // const pathName = window.location.pathname;
                const queryParams = to.query;

                if (queryParams["dev"]) {
                    //테스트 환경으로 들어올 경우
                    store.commit('setTestEvn', true);
                } else {
                    store.commit('setTestEvn', false);
                }

                if (queryParams["att"]) {
                    //첨부파일 URL로 들어올 경우 첨부파일 화면으로 이동
                    store.commit('setCurrentPage', 'att');
                    store.commit('setIsEncrypted', 'Y');
                    store.commit('setPasscode', queryParams["att"]);
                    store.commit('setUserSeq', 0);
                } else {
                    //그외 회원가입 프로세스로 이동
                    store.commit('setCurrentPage', 'intro');
                    store.commit('setIsEncrypted', 'N');
                    store.commit('setPasscode', '');
                    store.commit('setUserSeq', 0);
                }

                store.commit('resetSocialLoginInfo');
                /**
                 * 서브도메인 분기
                 * join: 차주앱
                 * joina: 아틀란
                 * joinm: 만차로
                 */
                const hostUrl = window.location.hostname;
                const subDomainName = hostUrl.split('.')[0];
                // let subDomainName = "joinm";
                const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
                /**
                 * 접속url로 저장하기
                 */
                const queryParam = queryParams["join-url"] || "";
                sessionStorage.setItem("now-code", queryParam);

                // join-url 파라미터가 명시적으로 제공된 경우만 처리
                if (queryParams["join-url"]) {
                    const joinUrlParam = queryParams["join-url"];
                    console.log("joinUrlParam => ", joinUrlParam);

                    const hasAlpha = /[a-zA-Z]/.test(joinUrlParam);
                    const hasNumber = /[0-9]/.test(joinUrlParam);
                    const isOnlyNumber = /^\d+$/.test(joinUrlParam);

                    console.log("joinUrlParam 검증:", {
                        value: joinUrlParam,
                        hasAlpha,
                        hasNumber,
                        isOnlyNumber
                    });

                    // 영어만 있는 경우 - 잘못된 경로
                    if (hasAlpha && !hasNumber) {
                        console.log("영어만 있음 - 잘못된 경로");
                        alert("잘못된 접근 경로입니다.");
                        sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                        sessionStorage.removeItem("jibu-name"); // 지부명 삭제
                    }
                    // 영어+숫자 조합 - 암호화된 코드, 복호화 API 호출
                    else if (hasAlpha && hasNumber) {
                        console.log("영어+숫자 조합 - 복호화 API 호출 시작");
                        try {
                            const response = await HTTP.post('/api/user/join/decrypt/key', {
                                value: joinUrlParam
                            });

                            const responseData = response.data;
                            if (!responseData.error && responseData.data && responseData.data.decrypted_value) {
                                // 복호화 성공 - decrypted_value를 grade-code에 저장
                                const decryptedValue = responseData.data.decrypted_value;
                                sessionStorage.setItem("grade-code", decryptedValue);

                                // 지부명 조회 및 저장
                                const jibuName = getJibuName(decryptedValue);
                                if (jibuName) {
                                    sessionStorage.setItem("jibu-name", jibuName);
                                    console.log("지부명 저장:", jibuName);
                                } else {
                                    sessionStorage.removeItem("jibu-name"); // 매핑 없으면 삭제
                                }
                            } else {
                                // API 응답은 있지만 에러가 있는 경우
                                alert("가입 코드 확인에 실패했습니다. 다시 시도해주세요.");
                                sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                                sessionStorage.removeItem("jibu-name"); // 지부명 삭제
                            }
                        } catch (error) {
                            // 네트워크 오류 등
                            console.error("복호화 API 호출 실패:", error);
                            alert("가입 코드 확인 중 오류가 발생했습니다. 다시 시도해주세요.");
                            sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                            sessionStorage.removeItem("jibu-name"); // 지부명 삭제
                        }
                    }
                    // 순수 숫자 - 기존 날짜 범위 검증 로직
                    else if (isOnlyNumber) {
                        // 순수 숫자 코드는 지부명이 없으므로 삭제
                        sessionStorage.removeItem("jibu-name");

                        // 각 join-url 값에 따른 날짜 범위 지정
                        const allowedRanges = {
                            '100208': {start: "2024-12-31", end: "2025-12-19"}, // 휴게소 이벤트
                            '101108': {start: "2024-12-31", end: "2099-12-31"},
                            '102108': {start: "2024-12-31", end: "2099-12-31"},
                            '103108': {start: "2024-12-31", end: "2099-12-31"}  // 만트럭
                            // 다른 값에 대한 범위도 필요시 추가
                        };

                        if (allowedRanges[joinUrlParam]) {
                            // 현재 시간을 한국 시간으로 변환
                            const nowKST = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Seoul"}));

                            // 시작일: 해당 날짜의 00:00:00 (한국 시간)
                            const startDate = new Date(allowedRanges[joinUrlParam].start + "T00:00:00+09:00");
                            // 종료일: 해당 날짜의 23:59:59.999 (한국 시간)
                            const endDate = new Date(allowedRanges[joinUrlParam].end + "T23:59:59.999+09:00");

                            // 현재 날짜가 startDate와 endDate 사이(양쪽 포함)에 있는지 확인
                            if (nowKST >= startDate && nowKST <= endDate) {
                                sessionStorage.setItem("grade-code", joinUrlParam);
                            } else {
                                sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                            }
                        } else {
                            // allowedRanges에 정의되지 않은 값이면 기본값 저장
                            sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                        }
                    } else {
                        // 그 외의 경우 기본값 저장
                        sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                        sessionStorage.removeItem("jibu-name"); // 지부명 삭제
                    }
                } else {
                    // join-url 파라미터가 없는 경우
                    // /kakao에서 온 경우(실패 시 리다이렉트)는 지부명 유지, 그 외는 초기화
                    if (from.path !== '/kakao') {
                        sessionStorage.removeItem("jibu-name");
                        console.log("join-url 파라미터 없음, 지부명 초기화");
                    } else {
                        console.log("카카오에서 리다이렉트, 지부명 유지");
                    }

                    if (!sessionStorage.getItem("grade-code")) {
                        sessionStorage.setItem("grade-code", joinUrlSet.gradeCode);
                    }
                }
                store.commit('setGradeCode', joinUrlSet.gradeCode);
                store.commit('setJoinUrl', joinUrlSet.path);
                next(); // 이동을 계속합니다.
            },
        },
        {
            // 타 정산 가입페이지
            path: '/join/cal',
            name: 'JoinPointContainer',
            component: JoinPointContainer,
            beforeEnter: async (to, from, next) => {
                const queryParams = to.query;
                if (queryParams["dev"]) {
                    //테스트 환경으로 들어올 경우
                    store.commit('setTestEvn', true);
                } else {
                    store.commit('setTestEvn', false);
                }
                await store.commit('setCurrentPage', 'intro');
                const hostUrl = window.location.hostname;
                const subDomainName = hostUrl.split('.')[0];
                const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
                store.commit('setGradeCode', joinUrlSet.gradeCode);
                store.commit('setJoinUrl', joinUrlSet.path);
                next();
            },
        },
        {
            // 타 정산 가입페이지
            path: '/join/cal/kakao',
            name: 'JoinPointContainer',
            component: JoinPointSocialContainer,
            beforeEnter: async (to, from, next) => {
                await store.commit('setCurrentPage', 'intro');
                const hostUrl = window.location.hostname;
                const subDomainName = hostUrl.split('.')[0];
                const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
                store.commit('setGradeCode', 13); //13 예치금
                store.commit('setJoinUrl', joinUrlSet.path);

                HTTP.post('/api/kakao/access/cal', {
                    code: to.query.code,
                    joinUrl: store.getters.getJoinUrl // hmm, atl, mancharo ...
                })
                    .then(res => {
                        const responseData = res.data;
                        if (!responseData.error) { // 엑세스 토큰 확인 완료
                            store.commit('setAccessToken', responseData.data);
                            store.commit('setSocialCorpName', 'kakao');
                            next();
                        } else {
                            next({path: '/'});
                        }
                    })
                    .catch(() => {
                        alert("오류가 발생했습니다. 잠시후에 시도해주세요.");
                    })
            },
        },
        // {
        //     // 카카오 회원가입
        //     path: '/kakao',
        //     name: 'JoinSocialContainer',
        //     component: JoinSocialContainer,
        //     // eslint-disable-next-line
        //     beforeEnter: async (to, from, next) => {
        //         // code가 없으면 오류 페이지로 이동
        //         const code = to.query.code;
        //         if (!code) {
        //             next({path: '/kakaoError', query: {'error-code': 'invalid_kakao'}});
        //             return;
        //         }
        //         if (sessionStorage.getItem("grade-code") === '100208') {
        //             // 바로
        //             store.commit('setCurrentPage', 'event20');
        //         } else {
        //             store.commit('setCurrentPage', 'intro');
        //         }
        //         store.commit('setIsEncrypted', 'N');
        //         store.commit('setPasscode', '');
        //         store.commit('setUserSeq', 0);
        //         // store.commit('setKakaoCode',to.query.code);
        //         /**
        //          * 서브도메인 분기
        //          * join: 차주앱
        //          * joina: 아틀란
        //          * joinm: 만차로
        //          */
        //         const hostUrl = window.location.hostname;
        //         const subDomainName = hostUrl.split('.')[0];
        //         const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
        //         store.commit('setGradeCode', joinUrlSet.gradeCode);
        //         store.commit('setJoinUrl', joinUrlSet.path);
        //
        //         HTTP.post('/api/kakao/access', {
        //             code: to.query.code,
        //             joinUrl: store.getters.getJoinUrl // hmm, atl, mancharo ...
        //         })
        //             .then(res => {
        //                 console.log('res=>', res);
        //                 const responseData = res.data;
        //                 if (!responseData.error) { // 엑세스 토큰 확인 완료
        //                     console.log(`responseData.data => `, responseData.data);
        //                     store.commit('setAccessToken', responseData.data);
        //                     store.commit('setSocialCorpName', 'kakao');
        //                     next();
        //                 } else {
        //                     // 이벤트라면 바로 회원가입 완료로 넘어가게 한다.
        //                     next({path: '/'});
        //                 }
        //             })
        //             .catch(() => {
        //                 // 네트워크 오류 등 예외 처리
        //                 next({
        //                     path: '/kakaoError',
        //                     query: {'error-code': 'network_error'}
        //                 });
        //             })
        //     },
        // },
        {
            // 카카오 회원가입
            path: '/kakao',
            name: 'JoinSocialContainer',
            component: JoinSocialContainer,
            // eslint-disable-next-line
            beforeEnter: async (to, from, next) => {
                // 저장된 토큰이 있으면 바로 진행
                const storedToken = sessionStorage.getItem('kakaoAccessToken');
                if (storedToken) {
                    store.commit('setAccessToken', storedToken);
                    store.commit('setSocialCorpName', 'kakao');
                    if (sessionStorage.getItem("grade-code") === '100208') {
                        store.commit('setCurrentPage', 'event20');
                    } else {
                        store.commit('setCurrentPage', 'intro');
                    }
                    store.commit('setIsEncrypted', 'N');
                    store.commit('setPasscode', '');
                    store.commit('setUserSeq', 0);
                    next();
                    return;
                }

                // code가 없으면 오류 페이지로 이동
                const code = to.query.code;
                if (!code) {
                    next({ path: '/kakaoError', query: { 'error-code': 'invalid_kakao' } });
                    return;
                }

                // 기존 비즈니스 로직 유지
                if (sessionStorage.getItem("grade-code") === '100208') {
                    store.commit('setCurrentPage', 'event20');
                } else {
                    store.commit('setCurrentPage', 'intro');
                }
                store.commit('setIsEncrypted', 'N');
                store.commit('setPasscode', '');
                store.commit('setUserSeq', 0);

                // 서브도메인 분기
                const hostUrl = window.location.hostname;
                const subDomainName = hostUrl.split('.')[0];
                const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
                store.commit('setGradeCode', joinUrlSet.gradeCode);
                store.commit('setJoinUrl', joinUrlSet.path);

                try {
                    const res = await HTTP.post('/api/kakao/access', {
                        code: code,
                        joinUrl: store.getters.getJoinUrl
                    });
                    console.log('res=>', res);
                    const responseData = res.data;

                    if (!responseData.error) { // 엑세스 토큰 확인 완료
                        console.log(`responseData.data => `, responseData.data);
                        store.commit('setAccessToken', responseData.data);
                        store.commit('setSocialCorpName', 'kakao');
                        sessionStorage.setItem('kakaoAccessToken', responseData.data);

                        // URL에서 쿼리 파라미터 제거
                        window.history.replaceState({}, document.title, '/kakao');
                        next();
                    } else {
                        // 서버에서 오류가 반환된 경우
                        next({
                            path: '/kakaoError',
                            query: { 'error-code': responseData.error || 'invalid_kakao' }
                        });
                    }
                } catch (err) {
                    console.error('에러 발생:', err);
                    // 네트워크 오류 등 예외 처리
                    next({
                        path: '/kakaoError',
                        query: { 'error-code': 'network_error' }
                    });
                }
            },
        },
        // router/index.js
        {
            path: '/kakaoError',
            name: 'KakaoError',
            component: KakaoErrorPage,
            props: route => ({errorCode: route.query['error-code']})
        },

        // {
        //     // 추가정보 기입화면
        //     path:'/info',
        //     name:'MemberInfoNew',
        //     component: MemberInfoNew,
        //     beforeEnter: (to, from, next) => {
        //         if (sessionStorage.getItem("grade-code") === '100208') {
        //             // 바로
        //             store.commit('setCurrentPage','event20');
        //         } else {
        //             store.commit('setCurrentPage','intro');
        //         }
        //         store.commit('setIsEncrypted','N');
        //         store.commit('setPasscode','');
        //         store.commit('setUserSeq',0);
        //         // store.commit('setKakaoCode',to.query.code);
        //         /**
        //          * 서브도메인 분기
        //          * join: 차주앱
        //          * joina: 아틀란
        //          * joinm: 만차로
        //          */
        //         const hostUrl = window.location.hostname;
        //         const subDomainName = hostUrl.split('.')[0];
        //         const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
        //         store.commit('setGradeCode',joinUrlSet.gradeCode);
        //         store.commit('setJoinUrl',joinUrlSet.path);
        //         next();
        //     },
        // },
        // {
        //     // 첨부서류 화면
        //     path:'/att',
        //     name:'MemberPaperAttachNew',
        //     component: MemberPaperAttachNew,
        //     beforeEnter: (to, from, next) => {
        //         if (sessionStorage.getItem("grade-code") === '100208') {
        //             // 바로
        //             store.commit('setCurrentPage','event20');
        //         } else {
        //             store.commit('setCurrentPage','intro');
        //         }
        //         store.commit('setIsEncrypted','N');
        //         store.commit('setPasscode','');
        //         store.commit('setUserSeq',0);
        //         // store.commit('setKakaoCode',to.query.code);
        //         /**
        //          * 서브도메인 분기
        //          * join: 차주앱
        //          * joina: 아틀란
        //          * joinm: 만차로
        //          */
        //         const hostUrl = window.location.hostname;
        //         const subDomainName = hostUrl.split('.')[0];
        //         const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
        //         store.commit('setGradeCode',joinUrlSet.gradeCode);
        //         store.commit('setJoinUrl',joinUrlSet.path);
        //         next();
        //     },
        // },
        // {
        //     // 네이버 회원가입
        //     path:'/naver',
        //     name:'JoinSocialContainer',
        //     component: JoinSocialContainer,
        //     // eslint-disable-next-line
        //     beforeEnter: async (to, from, next) => {
        //         store.commit('setCurrentPage','intro');
        //         store.commit('setIsEncrypted','N');
        //         store.commit('setPasscode','');
        //         store.commit('setUserSeq',0);
        //         // store.commit('setKakaoCode',to.query.code);
        //         /**
        //          * 서브도메인 분기
        //          * join: 차주앱
        //          * joina: 아틀란
        //          * joinm: 만차로
        //          */
        //         const hostUrl = window.location.hostname;
        //         const subDomainName = hostUrl.split('.')[0];
        //         const joinUrlSet = store.getters.getJoinUrlSet(subDomainName);
        //         store.commit('setGradeCode',joinUrlSet.gradeCode);
        //         store.commit('setJoinUrl',joinUrlSet.path);
        //         const redirectUrl = 'http://192.168.0.213:9090/api/naver/' + store.getters.getJoinUrl;
        //
        //
        //         HTTP.post('/api/naver/access', {
        //             code:to.query.code,
        //             state:encodeURI(redirectUrl),
        //             joinUrl: store.getters.getJoinUrl // hmm, atl, mancharo ...
        //         })
        //             .then(res=>{
        //                 const responseData = res.data;
        //                 if (!responseData.error) { // 엑세스 토큰 확인 완료
        //                     store.commit('setAccessToken',responseData.data);
        //                     store.commit('setSocialCorpName','naver');
        //                     next();
        //                 } else {
        //                     next( {path:'/'} );
        //                 }
        //             })
        //             .catch((ex)=> {
        //                 console.log(ex);
        //                 alert("오류가 발생했습니다. 잠시후에 시도해주세요.");
        //                 // next( {path:'/'} );
        //             })
        //     },
        // },
        {   //본인인증
            path: '/auth',
            name: 'auth',
            meta: {order: 1},
            component: MainContainer
        },
    ]
});

// router.beforeEach((to, from, next)=>{
//     console.log(to.matched.length);
//     console.log(to.path);
//     console.log(from.path);
//     if (to.matched.length === 0) {
//         next({path:'*'});
//     } else {
//         next();
//     }
// })
export default router;